/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useState, useEffect, ChangeEvent, useRef } from 'react';
import type { AxiosError } from 'axios';

import { useStore } from '../../context/Store';
import { API } from '../../services/api';

export default () => {
  const {
    changeUserAuthenticated,
    changeNotification,
    changeGasStation,
    changeassociadoId,
    changePlate,
    changeFuels,
  } = useStore();

  const cardNumberRef = useRef<HTMLInputElement>();

  const [gasToken, setGasToken] = useState<string>('');
  const [modalGasTokenIsOpen, setModalGasTokenIsOpen] =
    useState<boolean>(false);
  const [cardNumber, setCardNumber] = useState<string>('');

  const [alert, setAlert] = useState<string>('');

  const [showVoucherButton, setShowVoucherButton] = useState<boolean>(() => {
    const voucher = localStorage.getItem('voucher');
    return voucher === 'true';
  });

  useEffect(() => {
    if (!modalGasTokenIsOpen && cardNumberRef.current) {
      const timer = setTimeout(() => {
        cardNumberRef.current?.focus();
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [modalGasTokenIsOpen]);

  const changeCardNumber = (event: ChangeEvent<HTMLInputElement> | any) => {
    const value = event.target.value.toUpperCase();

    // Determina o tipo baseado no primeiro caractere
    const isManualCode = /^[A-Z]/.test(value[0]);
    const isCardCode = /^[0-9]/.test(value[0]);

    if (isManualCode) {
      // Código manual: limita a 4 caracteres
      if (value.length > 4) return;

      // Caracteres 2-4 devem ser números
      if (value.length > 1) {
        const numbers = value.slice(1);
        if (!/^[0-9]*$/.test(numbers)) {
          return;
        }
      }

      setCardNumber(value);

      // Dispara com 4 caracteres
      if (value.length === 4) {
        getFuelsAndPlate(value);
      }
    } else if (isCardCode) {
      // Cartão: limita a 10 caracteres, todos devem ser números
      if (value.length > 10) return;

      if (!/^[0-9]*$/.test(value)) {
        return;
      }

      setCardNumber(value);

      // Dispara com 10 caracteres
      if (value.length === 10) {
        getFuelsAndPlate(value);
      }
    } else if (value.length > 0) {
      // Primeiro caractere inválido
      return;
    } else {
      // Campo vazio
      setCardNumber(value);
    }
  };

  const getFuelsAndPlate = async (plate: string) => {
    const idPosto = localStorage.getItem('idPosto');

    if (idPosto) {
      plate = plate.replaceAll(' ', '');
      try {
        const response = await API.get(
          `/api/v1/Associado/abastecimento-portal-posto?PostoId=${idPosto}&NClubGas=${plate}`,
        );

        console.log(response);

        if (response.data.isValid) {
          const { associadoId, placa, listCombustivel } = response.data;

          changeassociadoId(associadoId);
          changePlate(placa);
          changeFuels(listCombustivel);
          changeUserAuthenticated(true);
        }
      } catch (error: AxiosError | any) {
        const errors = error.response.data.errors;
        setCardNumber('');
        if (errors) {
          setCardNumber('');
          changeNotification('error', errors.join('\n'));
        } else {
          setCardNumber('');
          changeNotification('error', 'Erro no aplicativo, tente novamente!.');
        }
      }
    } else {
      setAlert('Por favor informe o TOKEN do posto');
      setModalGasTokenIsOpen(true);
    }
  };

  const deleteCardNumber = (event: any) => {
    if (event.key === 'Backspace') {
      const deleteLastCharacter = cardNumber.substring(
        0,
        cardNumber.length - 1,
      );
      setCardNumber(deleteLastCharacter);
    }
  };

  const changeGasToken = (event: ChangeEvent<HTMLInputElement> | any) =>
    setGasToken(event.target.value);

  const handleGasTokenSubmit = async () => {
    if (gasToken) {
      try {
        const response = await API.get(
          `/api/v1/Posto/token?TokenPosto=${gasToken}`,
        );

        if (response && response.status === 200 && response.data.isValid) {
          const { idPosto, nomePosto, voucher } = response.data;
          let voucherStr = 'false';
          if (voucher === true || voucher === 'true') {
            voucherStr = 'true';
          }

          localStorage.setItem('idPosto', idPosto);
          localStorage.setItem('nomePosto', nomePosto);
          localStorage.setItem('voucher', voucherStr);

          setShowVoucherButton(voucherStr === 'true');

          setModalGasTokenIsOpen(false);
          changeGasStation(nomePosto);

          if (cardNumberRef && cardNumberRef.current) {
            cardNumberRef.current.focus();
          }
        }
      } catch (error) {
        setAlert('Erro ao obter TOKEN do posto. Por favor informe novamente.');
        setModalGasTokenIsOpen(true);
      }
    } else {
      setAlert('TOKEN do posto inválido. Por favor informe novamente.');
      setModalGasTokenIsOpen(true);
    }
  };

  const getInformation = async () => {
    const idPosto = localStorage.getItem('idPosto');

    if (idPosto) {
      try {
        const response = await API.get(`/api/v1/Posto/byId?idPosto=${idPosto}`);

        if (response && response.status === 200 && response.data.isValid) {
          // byId returns a 'posto' object; read voucher from posto.voucher
          const voucher = response.data?.posto?.voucher;
          let voucherStr = 'false';
          if (voucher === true || voucher === 'true') {
            voucherStr = 'true';
          }
          localStorage.setItem('voucher', voucherStr);
          setShowVoucherButton(voucherStr === 'true');

          setModalGasTokenIsOpen(false);
        } else {
          setAlert('TOKEN do posto inválido. Por favor informe novamente.');
        }
      } catch (error) {
        setAlert('Erro ao obter TOKEN do posto. Por favor informe novamente.');
        setModalGasTokenIsOpen(true);
      }
    } else {
      setAlert('Por favor informe o TOKEN do posto');
      setModalGasTokenIsOpen(true);
    }
  };

  return {
    gasToken,
    changeGasToken,
    handleGasTokenSubmit,
    modalGasTokenIsOpen,
    cardNumber,
    changeCardNumber,
    deleteCardNumber,
    getInformation,
    alert,
    cardNumberRef,
    showVoucherButton,
  };
};
